import { Injectable } from '@angular/core';
import { AngularFirestore, CollectionReference, Query } from 'angularfire2/firestore';
import { AuthService } from '../auth/auth.service';
import * as firebase from 'firebase/app';
import 'firebase/storage'
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AngularFireDatabase } from '@angular/fire/database';
import { WhereFilterOp, OrderByDirection } from "@firebase/firestore-types";
import { ConnectivityService } from '../connectivity/connectivity.service';



@Injectable({
    providedIn: 'root'
})
export class ApiService {

    constructor(
        public db: AngularFirestore,
        public auth: AuthService,
        public angularfire: AngularFireDatabase,
        private http: HttpClient,
        private connectivity: ConnectivityService,
    ) { }

    async batchPresentation(brick, newVisibility: boolean): Promise<any> {
        return new Promise(async (resolve, reject) => {
            let batch = this.db.firestore.batch();
            let snippets;
    
            try {
                
                // Antes, al hacer visible un producto fuera de DO solo se tomaban
                // las presentaciones sincronizadas con SAP; sin SAP, todas.
                snippets = await this.getRef(`bricks/${brick.hasOwnProperty('brick') ? brick.brick : brick.$key}/presentations/`).ref.get();
                
                const element_size = snippets.size;
                let presentations = [];
                if (element_size > 0) {
                    for (const element of snippets.docs) {
                        const data = element.data();
                        data.visible = Number(data.inventory) > 0 && newVisibility == true ? true : false;
                        presentations.push(data);
                        batch.set(this.db.firestore.collection(`bricks/${brick.hasOwnProperty('brick') ? brick.brick : brick.$key}/presentations/`).doc(element.id), data);
                    }
                    
                }
                if (presentations.some((element) => element.visible == true)) {
                    resolve(true);
                } else {
                    resolve(false);
                }
    
                await batch.commit();
            } catch (error) {
                reject(error);
            }
        });
    }




    async batchReferencesBrick(brick, newVisibility: boolean):Promise<void>{
        let batch = this.db.firestore.batch();


        const snippets = await this.getRef("bricks")
        .ref.where("brick", "==", brick.$key)
        .get();
        
        const element_size = snippets.size;
        if (element_size > 0) {
            for (const element of snippets.docs) {
                let data = element.data();
                data.visible= newVisibility;
                batch.set(this.db.firestore.collection('bricks').doc(element.id), data);
            }
        }
        
        await batch.commit();
    }


    /**
     * `options.source: 'cache'` responde desde la copia local sin esperar al
     * servidor; útil con señal débil o sin conexión para colecciones que ya
     * se escuchan en vivo (ver ConnectivityService.preferCache).
     */
    getAllDocuments(collection: string, options?: firebase.firestore.GetOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.db.collection(collection)
                .get(options)
                .toPromise()
                .then((querySnapshot) => {
                    let arr = [];
                    querySnapshot.forEach(function (doc) {
                        var obj = JSON.parse(JSON.stringify(doc.data()));
                        obj.$key = doc.id
                        arr.push(obj);
                    });

                    if (arr.length > 0) {
                        resolve(arr);
                    } else {
                        resolve(null);
                    }


                })
                .catch((error: any) => {
                    if (error.code === 'permission-denied') {
                        console.error('No tienes permiso para acceder a este documento');
                        reject(null);
                    } else {
                        console.error(error);
                        reject(error);
                    }
                });
        });
    }

    // ── Caché corta de documentos de configuración ─────────────────────────
    // `configurations/<país>` (asignaciones de eventos, banderas) y
    // `stores/<tienda>` los piden el menú, el monitor, la configuración del
    // evento, la zona y los informes, cada uno por su lado y en la misma
    // navegación. Firestore no evita el viaje al servidor en get(), así que
    // se comparte la lectura durante unos segundos; cualquier escritura desde
    // aquí la invalida.
    private static readonly CACHED_COLLECTIONS: { [collection: string]: number } = { configurations: 30000, stores: 30000, events: 10000 };
    private docCache: { [path: string]: { at: number; promise: Promise<any> } } = {};

    private cachePath(collection: string, documentId: string): string {
        return `${collection}/${documentId}`;
    }

    /** Olvida la copia de un documento (o de toda la caché) tras escribirlo. */
    forgetDocument(collection?: string, documentId?: string) {
        if (!collection) { this.docCache = {}; return; }
        delete this.docCache[this.cachePath(collection, documentId)];
    }

    getDocument(collection, documentId, options?: firebase.firestore.GetOptions): Promise<any> {
        const ttl = ApiService.CACHED_COLLECTIONS[collection];
        if (!ttl || options) return this.readDocument(collection, documentId, options);

        const path = this.cachePath(collection, documentId);
        const hit = this.docCache[path];
        if (!hit || Date.now() - hit.at >= ttl) {
            const promise = this.readDocument(collection, documentId);
            this.docCache[path] = { at: Date.now(), promise };
            promise.catch(() => { delete this.docCache[path]; });
        }
        // Copia superficial: cada pantalla recibe su propio objeto, como antes.
        return this.docCache[path].promise.then(doc => ({ ...doc }));
    }

    private readDocument(collection, documentId, options?: firebase.firestore.GetOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.db.collection(collection).doc(documentId)
                .get(options)
                .toPromise()
                .then((snapshot) => {
                    let doc = snapshot.data();
                    doc["$key"] = snapshot.id;
                    resolve(doc);
                }).catch((error: any) => {
                    if (error.code === 'permission-denied') {
                        console.error('No tienes permiso para acceder a este documento');
                        reject(null);
                    } else {
                        console.error(error);
                        reject(error);
                    }
                });
        })
        // return this.firestore.collection('songList').doc(songId);
    }


    getDocumentCategories(collection, documentId) {
        return new Promise((resolve, reject) => {
            this.db.collection(collection).doc(documentId)
                .get()
                .toPromise()
                .then((snapshot) => {
                    let doc = snapshot.data();
                    if(snapshot.exists){
                     doc["$key"] = snapshot.id;
                     resolve(doc);
                    }else{
                        resolve(null)
                        this.updateDocument("bricks", documentId, {delete: true, deleteDetails: {date: new Date(), user: this.auth.email}} )
                    }
    
                }).catch((error: any) => {
                    if (error.code === 'permission-denied') {
                        console.error('No tienes permiso para acceder a este documento');
                        reject(null);
                    } else {
                        reject(error);
                    }
                });
        })
        // return this.firestore.collection('songList').doc(songId);
    }

    deleteDocument(collectionName: string, docID: string): Promise<any> {
        return new Promise((resolve, reject) => {
            this.db
                .collection(collectionName)
                .doc(docID)
                .delete()
                .then((obj: any) => {
                    resolve(obj);
                })
                .catch((error: any) => {
                    reject(error);
                });
        });
    }

    addDocument(collectionName: string, dataObj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            this.db.collection(collectionName).add(dataObj)
                .then((obj: any) => {
                    resolve(obj);
                })
                .catch((error: any) => {
                    if (error.code === 'permission-denied') {
                        console.error('No tienes permiso para acceder a este documento');
                        reject(null);
                    } else {
                        console.error(error);
                        reject(error);
                    }
                });
        });
    }

    updateDocument(collectionName: string, docID: string, dataObj: any): Promise<any> {
        this.forgetDocument(collectionName, docID);
        return new Promise((resolve, reject) => {
            this.db
                .collection(collectionName)
                .doc(docID)
                .update(dataObj)
                .then((obj: any) => {
                    resolve(obj);
                })
                .catch((error: any) => {
                    if (error.code === 'permission-denied') {
                        console.error('No tienes permiso para acceder a este documento');
                        reject(null);
                    } else {
                        console.error(error);
                        reject(error);
                    }
                });
        });
    }

    ///////////////////////////////
    /////////////ESCRITURAS EN COLA (operación sin conexión)
    ///////////////////////////////

    /**
     * Igual que addDocument, pero no espera la confirmación del servidor:
     * Firestore aplica el cambio en la copia local, lo persiste en IndexedDB
     * y lo envía solo cuando haya conexión. Devuelve el id generado en el
     * dispositivo. Para la operación del evento (crear orden, descontar
     * inventario, cerrar caja): la pantalla no se queda esperando si se cae
     * el internet. Si el servidor rechaza la escritura (reglas, datos
     * inválidos) se avisa por ConnectivityService.writeFailed$.
     */
    addDocumentQueued(collectionName: string, dataObj: any): string {
        // El id se genera aquí: AngularFirestoreCollection.doc() sin argumento
        // reenvía `undefined` al SDK y este lanza ("requires its first argument
        // to be of type non-empty string"); solo el SDK crudo acepta doc() vacío.
        const id = this.db.createId();
        const ref = this.db.collection(collectionName).doc(id).ref;
        this.queueWrite(ref.set(dataObj), `add ${collectionName}/${id}`);
        return id;
    }

    updateDocumentQueued(collectionName: string, docID: string, dataObj: any): void {
        this.forgetDocument(collectionName, docID);
        this.queueWrite(
            this.db.collection(collectionName).doc(docID).update(dataObj),
            `update ${collectionName}/${docID}`
        );
    }

    setDocumentQueued(collectionName: string, docID: string, dataObj: any, options?: firebase.firestore.SetOptions): void {
        this.forgetDocument(collectionName, docID);
        this.queueWrite(
            this.db.collection(collectionName).doc(docID).set(dataObj, options),
            `set ${collectionName}/${docID}`
        );
    }

    private queueWrite(write: Promise<void>, label: string) {
        // Nadie espera esta promesa: el catch evita un "unhandled rejection".
        // El rechazo ya queda registrado y avisado por trackWrite.
        this.connectivity.trackWrite(write, label).catch(() => { });
    }

    ///////////////////////////////
    /////////////CUSTOM API REQUESTS
    ///////////////////////////////

    public getCollection$ = (
		collection: string,
		// events: DocumentChangeType[],
		filters: { field: string; comparison: WhereFilterOp; value: any }[] = [],
		order: string | null = null,
		direction: OrderByDirection | undefined = undefined
	) => {
        return this.db.collection<any>(collection,(ref)=> {
            let query: CollectionReference | Query = ref;
            if (filters.length > 0) {
				filters.forEach((filter) => {
					query = query.where(filter.field, filter.comparison, filter.value);
				});
			}
            if (order !== null && direction !== undefined) {
				query = query.orderBy(order, direction);
			}
            return query
        }).valueChanges({ idField: '$key' })
        
	};

    getRef(collection) {
        return this.db.collection(collection);
    }


    uploadSectionImage(brick, image) {
        return new Promise((resolve, reject) => {
            // //console.log(brick);

            let storageRef = firebase.storage().ref();
            const filename = this.generateUUID();
            let imageRef = storageRef.child(`categories/${brick}/${filename}.png`);

            imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                .then(data => {
                    let photoData = {};
                    photoData['fullPath'] = data.metadata.fullPath;
                    photoData['size'] = data.metadata.size;
                    photoData['contentType'] = data.metadata.contentType;
                    photoData['md5Hash'] = data.metadata.md5Hash;
                    photoData['bucket'] = data.metadata.bucket;
                    photoData['updated'] = data.metadata.updated;
                    imageRef.getDownloadURL().then(data => {
                        // //console.log(data);

                        photoData['downloadURL'] = data;
                        resolve(photoData);
                    });
                })
        })
    }

    uploadImage(path, image) {
        return new Promise((resolve, reject) => {
            let storageRef = firebase.storage().ref();
            let imageRef = storageRef.child(path);
            console.log( firebase.storage.StringFormat.DATA_URL)
            imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                .then(data => {
                    let photoData = {};
                    photoData['fullPath'] = data.metadata.fullPath;
                    photoData['size'] = data.metadata.size;
                    photoData['contentType'] = data.metadata.contentType;
                    photoData['md5Hash'] = data.metadata.md5Hash;
                    photoData['bucket'] = data.metadata.bucket;
                    photoData['updated'] = data.metadata.updated;
                    imageRef.getDownloadURL().then(data => {
                        photoData['downloadURL'] = data;
                        resolve(photoData);
                    });
                })
        })
    }

    uploadBrickImage(brick, image) {
        return new Promise((resolve, reject) => {
            let storageRef = firebase.storage().ref();
            const filename = this.generateUUID();
            let imageRef = storageRef.child(`categories/${brick}/${filename}.png`);

            imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                .then(data => {
                    let photoData = {};
                    photoData['fullPath'] = data.metadata.fullPath;
                    photoData['size'] = data.metadata.size;
                    photoData['contentType'] = data.metadata.contentType;
                    photoData['md5Hash'] = data.metadata.md5Hash;
                    photoData['bucket'] = data.metadata.bucket;
                    photoData['updated'] = data.metadata.updated;
                    imageRef.getDownloadURL().then(data => {

                        photoData['downloadURL'] = data;
                        resolve(photoData);
                    });
                })
        })
    }

    addBrick(brick_data, presentations, image,storeCopy?,categoryCopy?,multiStore?) {
        return new Promise((resolve, reject) => {

            let batch = this.db.firestore.batch();

            let brick_key = this.db.createId();
            brick_data.$key = brick_key
            brick_data.created_at = new Date();
            brick_data.account_email_create = this.auth.email

            let bar_codeArray = []

            presentations.forEach(element => {
                let presentation_key = this.db.createId();
                let { bar_code } = element

                if (this.auth.countryCode == "DO") {
                  if (!element.hasOwnProperty("inventory_ZONE1")) {
                    element.inventory_ZONE1 = 0;
                  }
                  if (!element.hasOwnProperty("inventory_ZONE2")) {
                    element.inventory_ZONE2 = 0;
                  }

                  element.inventory = element.inventory_ZONE1 + element.inventory_ZONE2
                }

                if (bar_code != undefined && bar_code != '') {
                    bar_codeArray.push(bar_code)
                }

                batch.set(this.db.firestore.collection(`bricks/${brick_key}/presentations/`).doc(presentation_key),
                    element
                );
            });

            if (bar_codeArray.length > 0) {
                brick_data['bar_code'] = bar_codeArray
            }

            if (image) {
                let storageRef = firebase.storage().ref();
                const filename = this.generateUUID();
                let imageRef = storageRef.child(`bricks/${brick_data.category}/${brick_key}/${filename}.png`);

                imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                    .then(data => {
                        let photoData = {};
                        let arrayImage = []
                        photoData['fullPath'] = data.metadata.fullPath;
                        photoData['size'] = data.metadata.size;
                        photoData['contentType'] = data.metadata.contentType;
                        photoData['md5Hash'] = data.metadata.md5Hash;
                        photoData['bucket'] = data.metadata.bucket;
                        photoData['updated'] = data.metadata.updated;
                        imageRef.getDownloadURL().then(dataResponse => {
                            // photoData['downloadURL'] = dataResponse;
                            brick_data.image = { 'downloadURL': '' }
                            brick_data.image['downloadURL'] = dataResponse;
                            brick_data.imagen_carrusel['downloadURL'][0] = dataResponse
                            if (brick_data.imagen_carrusel['downloadURL']) {
                                for (let i = 0; i < brick_data.imagen_carrusel['downloadURL'].length; i++) {
                                    if (brick_data.imagen_carrusel['downloadURL'][i] == '') {
                                        delete brick_data.imagen_carrusel['downloadURL'][i]
                                    } else {
                                        arrayImage.push(brick_data.imagen_carrusel['downloadURL'][i])
                                    }
                                }
                                brick_data.imagen_carrusel['downloadURL'] = arrayImage
                            }
                            batch.set(this.db.firestore.collection(`bricks`).doc(brick_key),
                                brick_data
                            );
                            batch.commit().then(data => {
                                resolve(null);
                            }).then(data => {
                                if(multiStore && multiStore == true){
                                try {
                                   
                                    
                                    this.http.post('https://reports.barlleno.app/service/barlleno/bricks/createbrick', {
                                        brickOriginal:brick_data.$key,
                                        newCategory:categoryCopy,
                                        newStoreCode:storeCopy.storeCode,
                                        newStore:storeCopy.$key,
                    
                                    }).subscribe((data) => {
                                        console.log(data)
                                    })
                                } catch (error) {
                                    
                                }
                                }})


                        });
                    })

            } else {
                let image_temp = 'https://firebasestorage.googleapis.com/v0/b/barlleno.appspot.com/o/public%2FiconBotella2021.png?alt=media&token=3f057adb-1ae2-4fdc-b3ff-a9ef6ab94dd1'
                brick_data.image = { 'downloadURL': '' }
                brick_data.image['downloadURL'] = image_temp;
                brick_data.imagen_carrusel['downloadURL'][0] = image_temp
                delete brick_data.imagen_carrusel

                batch.set(this.db.firestore.collection(`bricks`).doc(brick_key),
                    brick_data
                );

    


                batch.commit().then(data => {
                    resolve(null);
                }).then(data => {
                    if(multiStore && multiStore == true){
                    try {

                        this.http.post('https://reports.barlleno.app/service/barlleno/bricks/createbrick', {
                            brickOriginal:brick_data.$key,
                            newCategory:categoryCopy,
                            newStoreCode:storeCopy.storeCode,
                            newStore:storeCopy.$key,
        
                        }).subscribe((data) => {
                            console.log(data)
                        })
                    } catch (error) {
                        
                    }
                    }}
                )
            }


         
            
        });
    }

    addExplore(brick_data, presentations, image) {
        return new Promise((resolve, reject) => {

            let batch = this.db.firestore.batch();
            let brick_key = this.db.createId();
            brick_data.created_at = new Date();

            if (image) {
                let storageRef = firebase.storage().ref();
                const filename = this.generateUUID();
                let imageRef = storageRef.child(`explore/${brick_data.category}/${brick_key}/${filename}.png`);

                imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                    .then(data => {
                        let photoData = {};
                        photoData['fullPath'] = data.metadata.fullPath;
                        photoData['size'] = data.metadata.size;
                        photoData['contentType'] = data.metadata.contentType;
                        photoData['md5Hash'] = data.metadata.md5Hash;
                        photoData['bucket'] = data.metadata.bucket;
                        photoData['updated'] = data.metadata.updated;
                        imageRef.getDownloadURL().then(data => {
                            photoData['downloadURL'] = data;
                            brick_data.image = photoData;
                            batch.set(this.db.firestore.collection(`explore`).doc(brick_key),
                                brick_data
                            );
                            //console.log(brick_data);
                            batch.commit().then(data => {
                                resolve(null);
                            })
                        });
                    })

            } else {
                batch.set(this.db.firestore.collection(`explore`).doc(brick_key),
                    brick_data
                );
                batch.commit().then(data => {
                    resolve(null);
                })
            }
        });
    }

    updateBrick(brick_data, presentations, on_presentations, image, superbPresentations = [], superb_on_presentations = [], comercios_on_presentations = []) {
        return new Promise(async (resolve, reject) => {
            // //console.log("brick_data = ", brick_data, typeof brick_data, "delete = true" );
            if (brick_data['reference']) {
                delete brick_data['position']
                delete brick_data['reference']
            } else {
                delete brick_data['position']
            }

            if (brick_data['bar_code']) {
                delete brick_data['bar_code']
            }

            let batch = this.db.firestore.batch();
            delete brick_data["account_email_update_log"]

            
            
            
            this.addDocument(`bricks/${brick_data.$key}/history`, {
                date: new Date(),
                action: "modificationBrick",
                user: this.auth.email,
                newData: brick_data,
                presentationData: presentations,
                onPresentationData: on_presentations,
                superbPresentationData: superbPresentations,
                comercios_on_presentations: comercios_on_presentations
            })
            brick_data.update_at = new Date();

            let bar_codeArray = []
            presentations.forEach(element => {
                // console.log("element => ", element)
                let { bar_code } = element;

                if(this.auth.countryCode == 'DO'){
                    element.inventory = (element.inventory_ZONE1 ? element.inventory_ZONE1 : 0) + (element.inventory_ZONE2 ? element.inventory_ZONE2 : 0)
                }
                
                if(this.auth.countryCode == 'SV' && element.hasOwnProperty('discountPorcentage') && (element.discountPorcentage != '' || element.discountPorcentage != 0 || element.discountPorcentage != '0')){
                    element.undiscounted_price = Number((Number(element.price) + (element.price * (Number(element.discountPorcentage)/100))).toFixed(2))
                }
                if(element.hasOwnProperty('newPorcentage')){
                    delete element.newPorcentage
                    delete element.undiscounted_price
                }

                // if(this.auth.countryCode != 'SV' && element.hasOwnProperty('newPorcentage') && (element.newPorcentage != '' || element.newPorcentage != 0 || element.newPorcentage != '0')){
                //         if(element.hasOwnProperty('newPorcentage') && element.hasOwnProperty('discountPorcentage') && element.newPorcentage != element.discountPorcentage){
                //             console.log("entro")
                //             element.undiscounted_price = element.price
                //             element.discountPorcentage = element.newPorcentage;
                //             element.price = Number((Number(element.price) - (element.price * (Number(element.discountPorcentage)/100))).toFixed(2))
                            
                //         }
                        
                // }
                
                if (bar_code != undefined && bar_code != '') {
                    bar_codeArray.push(bar_code)
                }
                
                if (element.price_bin > 0) {
                    console.log("element.price_bin => ", element.price_bin)
                    batch.update(this.db.firestore.collection(`bricks/${brick_data.$key}/presentations/`).doc(element.$key),
                        element
                    );
                }
                else {
                    // delete element.price_bin
                    
                    batch.update(this.db.firestore.collection(`bricks/${brick_data.$key}/presentations/`).doc(element.$key),
                        element
                    );
                    batch.update(this.db.firestore.collection(`bricks/${brick_data.$key}/presentations/`).doc(element.$key), { price_bin: firebase.firestore.FieldValue.delete() });
                }

                if (element.quantity_limit && (element.quantity_limit <= 0 || element.quantity_limit == '' || element.quantity_limit == undefined)) {
                    batch.update(this.db.firestore.collection(`bricks/${brick_data.$key}/presentations/`).doc(element.$key), { quantity_limit: firebase.firestore.FieldValue.delete() });
                }

                

                if (element.hasOwnProperty('discountPorcentage') && (element.discountPorcentage === '' || element.discountPorcentage <= 0 || element.discountPorcentage === '0' || element.discountPorcentage === null)){
                    
                    if(element.hasOwnProperty('undiscounted_price') && element.hasOwnProperty('discountPorcentage')){
                        batch.update(this.db.firestore.collection(`bricks/${brick_data.$key}/presentations/`).doc(element.$key), { discountPorcentage: firebase.firestore.FieldValue.delete(),  undiscounted_price: firebase.firestore.FieldValue.delete()});
                    }else{
                        batch.update(this.db.firestore.collection(`bricks/${brick_data.$key}/presentations/`).doc(element.$key), { discountPorcentage: firebase.firestore.FieldValue.delete(), undiscounted_price: firebase.firestore.FieldValue.delete()});
                    }
                }

                if(element.hasOwnProperty('newPorcentage')){
                    batch.update(this.db.firestore.collection(`bricks/${brick_data.$key}/presentations/`).doc(element.$key), { undiscounted_price: firebase.firestore.FieldValue.delete(),  newPorcentage: firebase.firestore.FieldValue.delete()});
                }

            });

            if (bar_codeArray.length > 0) {
                brick_data['bar_code'] = bar_codeArray
            } else {
                brick_data['bar_code'] = null
            }

            // return
            on_presentations.forEach(element => {
                batch.update(this.db.firestore.collection(`bricks/${brick_data.$key}/on_presentations/`).doc(element.$key),
                    element
                );
            });

            // manejo de collections superb
            superbPresentations.forEach(element => {
                batch.update(this.db.firestore.collection(`bricks/${brick_data.$key}/superb_presentations/`).doc(element.$key),
                    element
                );
            });
            comercios_on_presentations.forEach(element => {
                batch.update(this.db.firestore.collection(`bricks/${brick_data.$key}/comercios_on_presentations/`).doc(element.$key),
                    element
                );
            });


            superb_on_presentations.forEach(element => {
                batch.update(this.db.firestore.collection(`bricks/${brick_data.$key}/superb_on_presentations/`).doc(element.$key),
                    element
                );
            });
            // fin de manejo de collections superb
            // console.log("brick_data = ", brick_data)

            if (image) {
                let storageRef = firebase.storage().ref();
                const filename = this.generateUUID();
                let imageRef = storageRef.child(`bricks/${brick_data.category}/${brick_data.$key}/${filename}.png`);

                imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                    .then(data => {
                        let photoData = {};
                        let arrayImage = []
                        photoData['fullPath'] = data.metadata.fullPath;
                        photoData['size'] = data.metadata.size;
                        photoData['contentType'] = data.metadata.contentType;
                        photoData['md5Hash'] = data.metadata.md5Hash;
                        photoData['bucket'] = data.metadata.bucket;
                        photoData['updated'] = data.metadata.updated;
                        imageRef.getDownloadURL().then(data => {
                            photoData['downloadURL'] = data;
                            brick_data.image = photoData;
                            // 
                            // console.log("data => ", data)
                            brick_data.imagen_carrusel['downloadURL'][0] = data
                            if (brick_data.imagen_carrusel['downloadURL']) {
                                for (let i = 0; i < brick_data.imagen_carrusel['downloadURL'].length; i++) {
                                    if (brick_data.imagen_carrusel['downloadURL'][i] == '') {
                                        delete brick_data.imagen_carrusel['downloadURL'][i]
                                    } else {
                                        arrayImage.push(brick_data.imagen_carrusel['downloadURL'][i])
                                    }
                                }
                                brick_data.imagen_carrusel['downloadURL'] = arrayImage
                            }
                            // 
                            batch.update(this.db.firestore.collection(`bricks`).doc(brick_data.$key),
                                brick_data
                            );
                            batch.commit().then(data => {
                                resolve(null);
                            })
                        });
                    })

            } else {
                batch.update(this.db.firestore.collection(`bricks`).doc(brick_data.$key),
                    brick_data
                );
                batch.commit().then(data => {
                    resolve(null);
                })
            }
        });
    }

    // eliminar campos de documento en base

    updateExplore(brick_data, image) {
        return new Promise((resolve, reject) => {

            let batch = this.db.firestore.batch();

            if (image) {
                let storageRef = firebase.storage().ref();
                const filename = this.generateUUID();
                let imageRef = storageRef.child(`explore/${brick_data.category}/${brick_data.$key}/${filename}.png`);

                imageRef.putString(image, firebase.storage.StringFormat.DATA_URL)
                    .then(data => {
                        let photoData = {};
                        photoData['fullPath'] = data.metadata.fullPath;
                        photoData['size'] = data.metadata.size;
                        photoData['contentType'] = data.metadata.contentType;
                        photoData['md5Hash'] = data.metadata.md5Hash;
                        photoData['bucket'] = data.metadata.bucket;
                        photoData['updated'] = data.metadata.updated;
                        imageRef.getDownloadURL().then(data => {
                            photoData['downloadURL'] = data;
                            brick_data.image = photoData;
                            batch.update(this.db.firestore.collection(`explore`).doc(brick_data.$key),
                                brick_data
                            );
                            batch.commit().then(data => {
                                resolve(null);
                            })
                        });
                    })

            } else {
                batch.update(this.db.firestore.collection(`explore`).doc(brick_data.$key),
                    brick_data
                );
                batch.commit().then(data => {
                    resolve(null);
                })
            }
        });
    }

    private generateUUID(): string {
        function s4() {
            return Math.floor((1 + Math.random()) * 0x10000)
                .toString(16)
                .substring(1);
        }
        return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
            s4() + '-' + s4() + s4() + s4();
    }

    async sendPush(title, message, push_keys) {
        // let respAndroid = await this.sendPushAndroid(title, message, push_keys)
        // console.log("respAndroid = ", respAndroid)
        let respIos = await this.sendPushIos(title, message, push_keys)
        // console.log("respIos = ", respIos)
    }

    sendPushIos(title, message, push_keys) {
        //console.log(title);
        //console.log(message);

        return new Promise((resolve, reject) => {
            const post_data = {
                'app_id': 'fe552472-4831-4d56-b608-7672e23b3030',
                'headings': {
                    'en': title,
                    'es': title,
                },
                'contents': {
                    'en': message,
                    'es': message,
                },
                "include_player_ids": push_keys,
            }

            let headers = new HttpHeaders({
                'Authorization': `Basic ZDgwOTFiNjYtOTY5Ni00OGZhLThhMzktNzcyMzMzYjNiNmIz`
            });

            this.http.post('https://onesignal.com/api/v1/notifications', post_data, { headers: headers })
                .subscribe(response => {
                    resolve(response);
                }, error => {
                    reject(error);
                });
        });
    }

    // se modifica cuando la orden se le aplicaron los puntos desde monitor
    cancelOrder(order) {
        return new Promise(async (resolve, reject) => {
            let batch = this.db.firestore.batch();
            if (order.status == 'delivered') {
                await this.getDocument(`accounts`, order.account.$key).then(account => {
                    // contruyendo Key del country relacionado a la orden

                    // inicio de validaciones de los puntos points_remove_applied / points_add_applied
                    if (!(order.hasOwnProperty("points_revert_applied"))) {
                        let index_points
                        let index_points_partner;
                        let newPoints = `points_${this.auth.storeCode}_${this.auth.countryCode}`


                        if (order.countryCode == 'SV') {
                            index_points = newPoints // 'points'
                            index_points_partner = 'points_partner'
                        }
                        else {
                            index_points = newPoints // `points_${order.countryCode}`
                            index_points_partner = `points_partner_${order.countryCode}`
                        }

                        // para remover los puntos ganados en la compra
                        // obteniendo los puntos acount segun el order.countryCode
                        let country_points = 0
                        if (account.hasOwnProperty(index_points)) {
                            country_points = Number(account[index_points]) > 0 ? Number(account[index_points]) : 0;
                        }
                        let country_points_partner = 0
                        if (account.hasOwnProperty(index_points_partner)) {
                            country_points_partner = Number(account[index_points_partner]) > 0 ? Number(account[index_points_partner]) : 0
                        }
                        //console.log("country_points", country_points, "country_points_partner", country_points_partner)

                        // para revertir la compra de productos con Puntos en Club Barlleno
                        let points = country_points - (Number(order.points_earned) > 0 ? Number(order.points_earned) : 0) + (Number(order.total_points) > 0 ? Number(order.total_points) : 0)
                        if (points < 0) {
                            points = 0
                        }
                        let points_partner = country_points_partner - (Number(order.points_earned_partner) > 0 ? Number(order.points_earned_partner) : 0) + (Number(order.total_points_partner) > 0 ? Number(order.total_points_partner) : 0)
                        //console.log("set points_partner => ", points_partner)
                        if (points_partner < 0) {
                            points_partner = 0
                        }

                        batch.update(this.db.firestore.collection(`accounts`).doc(order.account.$key),
                            { [index_points]: points }
                        );

                        batch.update(this.db.firestore.collection(`accounts`).doc(order.account.$key),
                            { [index_points_partner]: points_partner }
                        );
                        // agregando nueva bandera para saber si los puntos fueron removidos de la cuenta del usuario
                        batch.update(this.db.firestore.collection(`orders`).doc(order.$key),
                            {
                                status: 'canceled',
                                points_revert_applied: true
                            }
                        );
                    } else {
                        // //console.log("no existen las banderas de control - points_remove_applied / points_add_applied")
                        batch.update(this.db.firestore.collection(`orders`).doc(order.$key),
                            {
                                status: 'canceled'
                            }
                        );
                    }

                    // fin de validaciones de los puntos points_remove_applied / points_add_applied

                    // batch.update(this.db.firestore.collection(`orders`).doc(order.$key),
                    //     {
                    //         status: 'canceled'
                    //     }
                    // );

                    batch.commit().then(async data => {
                        let respReverInventory = await this.revertInventory(order)
                        //console.log("respRevertInventory = ", respReverInventory)

                        resolve(null)
                    })
                })
            } else if (order.status == 'canceled') {
            } else {
                await this.getDocument(`accounts`, order.account.$key).then(account => {
                    // let points = account['points'] - Number(order.points_earned);
                    // contruyendo Key del country relacionado a la orden

                    // inicio de validaciones de los puntos points_remove_applied / points_add_applied
                    // if (!(order.hasOwnProperty("points_revert_applied")) && (order.hasOwnProperty("points_add_applied") || order.hasOwnProperty("points_remove_applied")) ) {
                    if (!(order.hasOwnProperty("points_revert_applied"))) {
                        let index_points
                        let index_points_partner;

                        // order.points_revert_applied = true

                        if (order.countryCode == 'SV') {
                            index_points = 'points'
                            index_points_partner = 'points_partner'
                        }
                        else {
                            index_points = `points_${order.countryCode}`
                            index_points_partner = `points_partner_${order.countryCode}`
                        }

                        // para remover los puntos ganados en la compra
                        // obteniendo los puntos acount segun el order.countryCode
                        let country_points = 0
                        if (account.hasOwnProperty(index_points)) {
                            country_points = Number(account[index_points]) > 0 ? Number(account[index_points]) : 0;
                        }
                        let country_points_partner = 0
                        if (account.hasOwnProperty(index_points_partner)) {
                            country_points_partner = Number(account[index_points_partner]) > 0 ? Number(account[index_points_partner]) : 0
                        }
                        //console.log("country_points", country_points, "country_points_partner", country_points_partner)

                        // para revertir la compra de productos con Puntos en Club Barlleno
                        let points = country_points + (Number(order.total_points) > 0 ? Number(order.total_points) : 0)
                        //console.log("set points => ", points)
                        if (points < 0) {
                            points = 0
                        }
                        let points_partner = country_points_partner + (Number(order.total_points_partner) > 0 ? Number(order.total_points_partner) : 0)
                        //console.log("set points_partner => ", points_partner)
                        if (points_partner < 0) {
                            points_partner = 0
                        }

                        batch.update(this.db.firestore.collection(`accounts`).doc(order.account.$key),
                            { [index_points]: points }
                        );

                        batch.update(this.db.firestore.collection(`accounts`).doc(order.account.$key),
                            { [index_points_partner]: points_partner }
                        );
                        // agregando nueva bandera para saber si los puntos fueron removidos de la cuenta del usuario
                        batch.update(this.db.firestore.collection(`orders`).doc(order.$key),
                            {
                                status: 'canceled',
                                points_revert_applied: true
                            }
                        );

                    } else {
                        // //console.log("no existen las banderas de control - points_remove_applied / points_add_applied")
                        batch.update(this.db.firestore.collection(`orders`).doc(order.$key),
                            {
                                status: 'canceled'
                            }
                        );
                    }

                    // fin de validaciones de los puntos points_remove_applied / points_add_applied

                    // batch.update(this.db.firestore.collection(`orders`).doc(order.$key),
                    //     {
                    //         status: 'canceled'
                    //     }
                    // );

                    batch.commit().then(async data => {
                        let respReverInventory = await this.revertInventory(order)
                        //console.log("respRevertInventory = ", respReverInventory)

                        //console.log("ingreso a metodo revertir visible / no visible segun existencias de inventario")
                        // order.bricks.forEach(async element => {
                        //     //console.log("item del brick")
                        //     //console.log(element);
                        //     let quantityRevert = element.quantity
                        //     let currentInvetory = 0
                        //     // this.getAllDocuments(`bricks/${element.brick_key}/presentations/${element.$key}/`).then(data => {
                        //     await this.getDocument(`bricks/${element.brick_key}/presentations/`, element.$key).then(data => {
                        //         //console.log("data bricks/${element.brick_key}/presentations/`, element.$key");
                        //         //console.log(data)
                        //         if (data) {
                        //             if (data['inventory'] >= 0) {
                        //                 currentInvetory = data['inventory']
                        //             } else {
                        //                 currentInvetory = 0
                        //             }

                        //             // //console.log("valores de los inventarios");
                        //             // //console.log("quantityRevert");
                        //             // //console.log(quantityRevert);
                        //             // //console.log("currentInvetory");
                        //             // //console.log(currentInvetory);

                        //             let batch = this.db.firestore.batch();

                        //             batch.update(this.db.firestore.collection(`bricks/${element.brick_key}/presentations/`).doc(element.$key),
                        //                 { inventory: quantityRevert + currentInvetory, visible: (quantityRevert + currentInvetory) > 0 ? true : false }
                        //             );

                        //             if (quantityRevert + currentInvetory > 0) {
                        //                 batch.update(this.db.firestore.collection(`bricks/`).doc(element.brick_key),
                        //                     { visible: true }
                        //                 );
                        //             }
                        //             batch.commit().then(data => {
                        //             })
                        //         }
                        //     })
                        // });
                    })
                })
            }
            resolve(null)
        })
    }

    async revertInventory(order) {
        return new Promise(async (resolve, reject) => {
            // console.log("revertInventory = ", order)
            let resp: any = false
            let respAjuste: any = false
            // account.legal_entity
            if (order.account.legal_entity == true) {
                resp = await this.revertInventoryAux(order, 'on_presentations')
                // console.log("resp = ", resp)
                respAjuste = await this.revertInventoryAjustON(order, 'presentations')
                // console.log(respAjuste)
            } else {
                resp = await this.revertInventoryAux(order, 'presentations')
                // console.log("resp = ", resp)
                // barlleno normal no afecta inventario de barlleno ON
            }

            resolve(resp)

        })
    }

    async revertInventoryAjustON(order, presentations) {
        return new Promise(async (resolve, reject) => {
            // console.log("revertInventoryAjust")
            for (let index = 0; index < order['bricks'].length; index++) {
                const element = order['bricks'][index];
                let flagExistencias = true;
                // console.log("revertInventoryAjustON = ", `bricks/${element.brick.$key}/${presentations}/`)
                await this.getDocument(`bricks/${element.brick.$key}/on_presentations/`, element.$key).then(async presentation => {
                    // console.log(presentation["presentation"]);
                    await this.getAllDocuments(`bricks/${element.brick.$key}/presentations/`).then(async item => {
                        if (item) {
                            for (let pos = 0; pos < item.length; pos++) {
                                const elementItem = item[pos];
                                let flagVisible = true
                                // console.log(elementItem)
                                if (elementItem.presentation == presentation["presentation"]) {
                                    let inventory = Number(elementItem.inventory) - Number(element.quantity);
                                    if (inventory <= 0) {
                                        inventory = 0;
                                        flagVisible = false
                                    }
                                    // console.log(`bricks/${element.brick.$key}/presentations/`, "elementItem.$key = ", elementItem.$key)
                                    await this.updateDocument(`bricks/${element.brick.$key}/presentations/`, elementItem.$key, {
                                        inventory: Number(inventory) > 0 ? Number(inventory) : 0,
                                        visible: flagVisible,
                                    }).then(async data => {
                                        // console.log("inventory", inventory);
                                        // console.log("elementItem.inventory", elementItem.inventory);
                                    })
                                }
                            }
                        }
                    })
                })
            }

            resolve(true)
        })
    }

    async revertInventoryAux(order, presentations) {
        return new Promise(async (resolve, reject) => {
            // console.log("ingreso a metodo revertir visible / no visible segun existencias de inventario")
            // order.bricks.forEach(async element => {
            // console.log("item del brick")
            // console.log(element);
            for (let index = 0; index < order['bricks'].length; index++) {
                const element = order['bricks'][index];
                //console.log("order['bricks'] element === ", element)
                if (true) {
                    let quantityRevert = element.quantity
                    let currentInvetory = 0
                    // this.getAllDocuments(`bricks/${element.brick_key}/presentations/${element.$key}/`).then(data => {
                    //console.log("revertInventoryAux ", `bricks/${element.brick_key}/${presentations}/`)
                    await this.getDocument(`bricks/${element.brick_key}/${presentations}/`, element.$key).then(data => {
                        // console.log("data bricks/${element.brick_key}/presentations/`, element.$key");
                        // console.log(data)
                        if (data) {
                            if (data['inventory'] >= 0) {
                                currentInvetory = data['inventory']
                            } else {
                                currentInvetory = 0
                            }

                            // console.log("valores de los inventarios");
                            // console.log("quantityRevert");
                            // console.log(quantityRevert);
                            // console.log("currentInvetory");
                            // console.log(currentInvetory);

                            let batch = this.db.firestore.batch();
                            //console.log("revertInventoryAux ", `bricks/${element.brick_key}/${presentations}/`)
                            batch.update(this.db.firestore.collection(`bricks/${element.brick_key}/${presentations}/`).doc(element.$key),
                                { inventory: quantityRevert + currentInvetory, visible: (quantityRevert + currentInvetory) > 0 ? true : false }
                            );

                            if (quantityRevert + currentInvetory > 0) {
                                batch.update(this.db.firestore.collection(`bricks/`).doc(element.brick_key),
                                    { visible: true }
                                );
                            }
                            batch.commit().then(data => {
                                resolve(true)
                            })
                        }
                    })
                }
            }
            // });
        })
    }


    // creacion de brick en mixology

    addDocumentKey(collectionName: string, dataObj: any): Promise<any> {
        return new Promise((resolve, reject) => {
            let brick_key = this.db.createId();
            dataObj.$key = brick_key
            let batch = this.db.firestore.batch();
            batch.set(this.db.firestore.collection(collectionName).doc(brick_key),
                dataObj
            );
            batch.commit().then(data => {
                resolve(brick_key);
            })
        });
    }

    GeneralInfo: any;

}


